<template>
    <div class="w-0 my-2 mx-2 mx-lg-0 mx-md-0">
        <div :class="{'position-absolute select-label fs-7': isStyled}" v-if="label.length" :style="{backgroundColor: bgColor}">
            {{ label }}
        </div>
        <div class="rounded-0 w-100 p-2 fs-6 bg-transparent border border-2" 
            style="border: 2px solid rgba(0,0,0,0.2) !important;">
            <!-- {{item.price}} -->
            <p class="fs-6 my-1" v-if="item.discountedPrice > 0" :class="{ 'apply-shake': shake }">
                <!-- <del style="color: #ea1a21"> -->
                    <strong style="color: #212529">
                        <!-- {{ item.salesPrice }}/-</strong> </del>&nbsp;
                <strong style="color: #ea1a21"> -->
                    {{ Math.round(item.discountedPrice).toLocaleString() }} &nbsp;
                </strong>
            </p>
            <p class="fs-6" :class="{ 'apply-shake': shake }" v-else>
               <strong>{{ Math.round(item.salesPrice).toLocaleString() }}</strong>
            </p>
        </div>
    </div>
</template>

<script setup>
import { useVModel } from "@/fuel-station/useVModel";

const props = defineProps({
    modelValue: {
        type: [Object, Array, String],
        default: {
            id: 0,
            name: "Select One"
        },
    },
    item: {
        type: Object,
        default: null,
    },
    label: {
        type: String,
        default: ""
    },
    isStyled: {
        type: Boolean,
        default: true
    },
    bgColor: {
        type: String,
        default: "#fff"
    }
});

const emit = defineEmits(['update:modelValue']);
const modelValueRef = useVModel(props, emit, "modelValue");

const qtyList = ref([
    {
        id: "qty0",
        name: 0,
        // selected: true,
    },
    {
        id: "qty1",
        name: 1,
    },
    {
        id: "qty2",
        name: 2,
    },
    {
        id: "qty3",
        name: 3,
    },
    {
        id: "qty4",
        name: 4,
    },
    {
        id: "qty5",
        name: 5,
    },
]);
const selectQty = ref(qtyList.value[0]);

const skuLabel = computed(() => {
    if (props.item?.skus?.length) {
        return props.item?.skus[0]?.label?.length && props.item?.skus[0]?.label != "base" ? props.item.skus[0]?.label : "";
    }
    return "";
})

watch(selectQty,
    (newVal) => {
        if (selectQty.value?.name > 0) {
            modelValueRef.value = {
                item: props.item,
                sku: props.item?.skus[0],
                quantity: selectQty.value?.name,
            }
        }
    },
    { immediate: true, deep: true }
);
</script>

<style lang="scss" scoped>
.select-label {
    top: -10px;
    left: 13px;
    z-index: 99;
    padding: 0 5px;
}


.form-select:focus {
    border-color: none !important;
    box-shadow: none !important;
}
</style>